import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, trackEvent, type AnalyticsEventParams } from '../utils/analytics';

/**
 * Hook to automatically initialize Google Analytics and record page views on route & hash changes.
 */
export const useAnalytics = () => {
	const location = useLocation();

	useEffect(() => {
		initGA();
	}, []);

	useEffect(() => {
		const fullPath = `${location.pathname}${location.search}${location.hash}`;
		trackPageView(fullPath);
	}, [location.pathname, location.search, location.hash]);

	return {
		trackEvent: (action: string, params?: AnalyticsEventParams) => trackEvent(action, params),
		trackPageView: (path?: string, title?: string) => trackPageView(path, title),
	};
};
